// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-OqN","expireSoon":"styles_expireSoon__xy7dP"};